"use client";

import dynamic from "next/dynamic";

// 서버가 카드까지 그려 보낸다.
// 예전에는 { ssr: false } 라 서버 HTML 에 틀만 있고 카드가 없었다 —
// 손님은 0.4~1.2초 동안 가운데가 하얀 화면을 봤다(2026-08-15 실측).
const ClientOnlyPage = dynamic(() => import("./feed-client"));

export default function ClientOnlyPageWrapper(props) {
  return <ClientOnlyPage {...props} />;
}
